<div class="modal-body d-flex flex-column align-items-center gap-3 text-muted m-0 px-5 py-4">
  <img src="/assets/images/messaging/whatsapp-message.webp" alt="" style="width: 5rem" />
  <h5 class="mb-3">
    <ng-container i18n>Send a</ng-container>&nbsp;<span class="text-whatsapp" i18n>Welcome Message?</span>
  </h5>
  <p class="mb-0" *ngIf="guest">
    <ng-container i18n> A welcome message will be sent to the guest on WhatsApp at </ng-container>
    <span class="text-semi-bold">{{ guest?.whatsapp_phone }}</span>
    <ng-container i18n> to ensure a smooth check-in experience. </ng-container>
  </p>
  <p class="mb-0" *ngIf="vendor">
    <ng-container i18n> A welcome message will be sent to the vendor on WhatsApp at </ng-container>
    <span class="text-semi-bold">{{ vendor?.whatsapp_number }}</span>
  </p>

  <app-loading-section *ngIf="isLoading && !compiledWhatsappTemplate"></app-loading-section>

  <p class="rounded p-2 bg-default text-sm align-self-stretch" *ngIf="compiledWhatsappTemplate">
    <textarea
      [value]="compiledWhatsappTemplate"
      readonly
      cdkTextareaAutosize
      class="border-0 p-0 w-100 bg-none"
      style="outline: none"
    >
    </textarea>
  </p>

  <p class="mb-3">
    <ng-container i18n>Would you like to</ng-container>&nbsp;<span class="text-dark text-semi-bold" i18n
      >send it now?</span
    >
  </p>

  <div class="d-flex align-items-center gap-2">
    <button class="btn btn-secondary-light" (click)="close()" i18n>No, Skip for Now</button>
    <button class="btn btn-secondary-info" [disabled]="isLoading" (click)="onSend()">
      <i class="cs-icon cs-icon-paper-plane2" *ngIf="!isLoading"></i>
      <i class="far fa-spinner fa-spin" *ngIf="isLoading"></i>
      <ng-container i18n>Yes, Send Now</ng-container>
    </button>
  </div>
</div>
